<form [formGroup]="form" (ngSubmit)="confirmar()" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4 w-full">
    <div class="flex flex-col">
        <label for="titularidad" class="font-semibold w-full">Titularidad*</label>
        <p-select [showClear]="true" [options]="opcionesSelect.titularidades" formControlName="titularidad" [appendTo]="'body'" class="w-full" placeholder="Seleccione una opción" />
        <app-input-error [control]="form.get('titularidad')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="cliente" class="font-semibold w-full">Empresa/Cliente*</label>
        <p-select [showClear]="!isPropio" [readonly]="isPropio" [options]="opcionesSelect.empresas" optionLabel="nombre" inputId="cliente" formControlName="empresa" placeholder="Seleccione una opción" [appendTo]="'body'" class="w-full" />
        <app-input-error [control]="form.get('cliente')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="interno" class="font-semibold w-full">Número de Interno*</label>
        <input pInputText type="number" id="interno" formControlName="interno" placeholder="Ingrese el número de interno" class="w-full" />
        <app-input-error [control]="form.get('interno')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="dominio" class="font-semibold w-full">Dominio*</label>
        <input type="text" pInputText id="dominio" formControlName="dominio" placeholder="Ingrese el dominio" />
        <app-input-error [control]="form.get('dominio')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="motor" class="font-semibold w-full">Número de Motor</label>
        <input pInputText type="number" id="motor" formControlName="motor" placeholder="Ingrese el número de motor" class="w-full" />
    </div>

    <div class="flex flex-col">
        <label for="motor" class="font-semibold w-full">Número de Chasis</label>
        <input pInputText type="number" id="chasis" formControlName="chasis" placeholder="Ingrese el número de chasis" class="w-full" />
    </div>

    <div class="flex flex-col">
        <label for="tipo" class="font-semibold w-full">Tipo de Vehiculo*</label>
        <p-select [showClear]="true" inputId="tipo" formControlName="tipo_vehiculo" placeholder="Ingrese el tipo de vehículo" [options]="opcionesSelect.tipos" optionLabel="nombre" class="w-full" appendTo="body" />
        <app-input-error [control]="form.get('tipo')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="idTacografo" class="font-semibold w-full">Identificador de Tacógrafo</label>
        <input pInputText type="number" id="idTacografo" formControlName="identificador_tacografo" placeholder="Ingrese el id" class="w-full" />
    </div>

    <div class="flex flex-col">
        <label for="marca" class="font-semibold w-full">Marca*</label>
        <p-select [showClear]="true" tinputId="marca" [options]="opcionesSelect.marcas" optionLabel="nombre" formControlName="marca" placeholder="Ingrese la marca del vehículo" appendTo="body" class="w-full" />
        <app-input-error [control]="form.get('marca')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="sector" class="font-semibold w-full">Sector*</label>
        <p-select [showClear]="true" inputId="sector" formControlName="sector" placeholder="Ingrese el sector" appendTo="body" [options]="opcionesSelect.sectores" optionLabel="siglas" class="w-full" />
        <app-input-error [control]="form.get('sector')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="distrito" class="font-semibold w-full">Distrito*</label>
        <p-select [showClear]="true" inputId="distrito" formControlName="distrito" placeholder="Ingrese el distrito" appendTo="body" [options]="opcionesSelect.distritos" optionLabel="siglas" class="w-full" />
        <app-input-error [control]="form.get('distrito')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="modelo" class="font-semibold w-full">Modelo</label>
        <input type="text" pInputText id="modelo" formControlName="modelo" placeholder="Ingrese el modelo del vehículo" class="w-full" />
        <app-input-error [control]="form.get('modelo')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="anio" class="font-semibold w-full">Año</label>
        <p-select [showClear]="true" inputId="anio" formControlName="anio" placeholder="Ingrese el año" class="w-full" appendTo="body" [options]="opcionesSelect.anios" />
        <app-input-error [control]="form.get('anio')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="combustible" class="font-semibold w-full">Tipo de Combustible</label>
        <p-select [showClear]="true" inputId="combustible" formControlName="tipo_combustible" placeholder="Seleccione una opción" appendTo="body" [options]="opcionesSelect.combustibles" class="w-full" />
    </div>

    <div class="flex flex-col">
        <label for="tacografo" class="font-semibold w-full">Tacógrafo</label>
        <p-select [showClear]="true" inputId="tacografo" formControlName="tacografo" placeholder="Seleccione una opción" appendTo="body" [options]="opcionesSelect.tacografos" class="w-full"> </p-select>
    </div>

    <div class="flex flex-col">
        <label for="asientos" class="font-semibold w-full">Asientos Disponibles</label>
        <input pInputText type="number" pInputNumber id="asientos" formControlName="asientos" placeholder="Ingrese la cantidad de asientos" class="w-full" />
    </div>

    <div class="flex flex-col col-span-1 md:col-span-2 lg:col-span-3">
        <label for="observaciones" class="font-semibold mb-1">Observaciones</label>
        <textarea rows="5" pTextarea formControlName="observaciones" placeholder="Espacio para otros datos" class="w-full"></textarea>
        <app-input-error [control]="form.get('observaciones')"></app-input-error>
    </div>

    <!-- Botones -->
    <div class="flex justify-end gap-3 col-span-1 md:col-span-2 lg:col-span-3 w-full">
        <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="cancelar()"></button>
        <button pButton type="submit" label="Confirmar" [disabled]="form.invalid"></button>
    </div>
</form>
